import { Checkbox } from '@mui/material'
import type { GridRenderEditCellParams } from '@mui/x-data-grid-pro'
import { useGridApiContext } from '@mui/x-data-grid-pro'
import React from 'react'

export const BooleanEditor: React.FC<GridRenderEditCellParams> = (params) => {
	const apiRef = useGridApiContext()
	return (
		<Checkbox
			checked={Boolean(params.value)}
			onChange={(e) => apiRef.current.setEditCellValue({ id: params.id, field: params.field, value: e.target.checked })}
			autoFocus
		/>
	)
}
